module.exports = __webpack_public_path__ + "img/star2.500896f9.png";